import { createSelector } from 'reselect';
import { getAlarmsHistory } from '../rootSelectors';

const isLoadingAlarmsWithFilter = createSelector([getAlarmsHistory], alarm => alarm.isLoadingAlarmsWithFilter);

export { isLoadingAlarmsWithFilter };
